// projectReducer.js

import { GET_USER_FORGOT_AUTH_FAILURE, GET_USER_FORGOT_AUTH_REQUEST, GET_USER_FORGOT_AUTH_SUCCESS, GET_USER_FORGOT_EMAIL_FAILURE, GET_USER_FORGOT_EMAIL_REQUEST, GET_USER_FORGOT_EMAIL_SUCCESS, USER_FORGOT_PASS_CHANGE_FAILURE, USER_FORGOT_PASS_CHANGE_REQUEST, USER_FORGOT_PASS_CHANGE_SUCCESS } from "../Actions/Actions";




const initialState = {
  isLoading: false,
  forgotPasswordData:{},
  forgotAuthData:{},
  resetPass:{},
  error: null,
  auth_error:null,
  change_error:null
};

const forogotPasswordReducer = (state = initialState,{type,payload}) => {
  switch (type) {
    case GET_USER_FORGOT_EMAIL_REQUEST:
      return { ...state, isLoading: true, error: null  };
    case GET_USER_FORGOT_EMAIL_SUCCESS:
      return { ...state, isLoading: false, forgotPasswordData:{...payload}};
    case GET_USER_FORGOT_EMAIL_FAILURE:
      return { ...state, isLoading: false, error: payload };
    
  case GET_USER_FORGOT_AUTH_REQUEST:
      return { ...state, isLoading: true, error: null  };
    case GET_USER_FORGOT_AUTH_SUCCESS:
      return { ...state, isLoading: false, forgotAuthData:{...payload}};
    case GET_USER_FORGOT_AUTH_FAILURE:
      return { ...state, isLoading: false, auth_error: payload };

       case USER_FORGOT_PASS_CHANGE_REQUEST:
      return { ...state, isLoading: true, error: null  };
    case USER_FORGOT_PASS_CHANGE_SUCCESS:
      return { ...state, isLoading: false, resetPass:{...payload}};
    case USER_FORGOT_PASS_CHANGE_FAILURE:
      return { ...state, isLoading: false, change_error: payload }; 

    default:
      return state;
  }
};

export default forogotPasswordReducer;
